import CommonConstants from './common-constants';

export function getEntityStateRenderer(state) {
    let icon: string = '';
    switch ( state ) {
        case CommonConstants.STATE.CREATE_IN_PROGRESS :
            icon = '<span class=\'label label-info\'>Creating</span>'
            break;
        case CommonConstants.STATE.DELETE_IN_PROGRESS :
            icon = '<span class=\'label label-info\'>Deleting</span>'
            break;
        case CommonConstants.STATE.ERROR :
            icon += '<span class=\'label label-danger\'>Failed</span>';
            break;
        case CommonConstants.STATE.NOT_REALIZED :
            icon = '<span class=\'label label-danger\'>Create Failed</span>';
            break;
        case CommonConstants.STATE.REALIZED :
            icon = '<span class=\'label label-success\'>Success</span';
            break;
        case CommonConstants.STATE.IN_PROGRESS :
            icon += '<span class=\'label label-info\'>Editing</span>';
            break;
        default:
            break;
    }
    return icon;
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/common/common-renderers.ts